import { render, staticRenderFns } from "./DataDiffTitle.vue?vue&type=template&id=488a4dd9&scoped=true&"
import script from "./DataDiffTitle.vue?vue&type=script&lang=ts&"
export * from "./DataDiffTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a4dd9",
  null
  
)

export default component.exports